import styled from 'styled-components';

export const HeaderSection = styled.div`
width: 100%;
box-sizing: border-box;
display: flex;
flex-flow: row nowrap;
align-items: center;
justify-content: space-between;
`;

export const LotteryContent = styled.div`
width: 100%;
box-sizing: border-box;
`;